export default __webpack_public_path__ + "static/media/Bracers of the Oxmal.aea1a9c6.jpg";